<template>
  <button
    class="btn btn--rounded"
    :class="[style, small, addClass]"
    :title="title"
    @click="click"
  >
    <span class="d--n" v-if="title.length > 0">
      {{ title }}
    </span>
    <q-icon :icon="icon" />
  </button>
</template>

<script>
const btnProps = {
  title: String,
  variant: {
    type: String,
    default: null
  },
  icon: {
    type: String,
    default: null,
    required: true
  },
  addClass: {
    type: String,
    default: null
  },
  size: {
    type: String,
    default: null
  }
};

export default {
  name: "q-button-icon",
  props: btnProps,
  methods: {
    click() {
      this.$emit("click");
    }
  },
  data() {
    return {
      style: this.variant == null ? "" : "btn--" + this.variant,
      small: this.variant == null ? "" : "btn--small"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/modules/button.scss";
</style>
